const isSameOrEarlierMonth = (month, year, compareMonth, compareYear) => {
  if (year === compareYear) {
    return month >= compareMonth;
  }

  return year > compareYear;
};

const isFutureMonth = (month, year, compareMonth, compareYear) => {
  return !isSameOrEarlierMonth(month, year, compareMonth, compareYear);
};

export { isSameOrEarlierMonth, isFutureMonth };
